import ServiceOptions from '../Components/PhotoOptions/ServiceOptions'
import Select, { createFilter } from 'react-select'
import NavyBranchOptions from '../Components/PhotoOptions/NavyBranchOptions'
import MarineBranchOptions from '../Components/PhotoOptions/MarineBranchOptions'
import { filterNewApprovalPhotos, filterNewGalleryPhotos, getObjectFromValue, getValueFromObject } from '../Functions'
import update from 'immutability-helper'
import React from 'react'

const BranchSearch = ({ setState, state, varNames }) => {
  const {
    [`${varNames.category}`]: category,
    [`${varNames.service}`]: service,
    [`${varNames.serviceBranch}`]: serviceBranch
  } = state
  const callbacks = {
    filterNewGalleryPhotos: ({ state, setState, varNames }) => {
      filterNewGalleryPhotos({ state, setState, varNames })
    },
    filterNewApprovalPhotos: ({ state, setState, varNames }) => {
      filterNewApprovalPhotos({ state, setState, varNames })
    }
  }

  return (
    <div className='search-branch'>
      {(() => {
        if (ServiceOptions.includes(category)) {
          return (
            <Select
              isClearable
              className='photos-search-container'
              options={(service === 'Navy') ? NavyBranchOptions : MarineBranchOptions}
              placeholder='Select a service branch...'
              onChange={(serviceBranch) => {
                callbacks[`${varNames.callback}`]({
                  state: update(state, {
                    [`${varNames.serviceBranch}`]: { $set: getValueFromObject(serviceBranch) || '' }
                  }),
                  setState: (state) => setState(state),
                  varNames
                })
              }}
              value={getObjectFromValue(
                serviceBranch,
                (service === 'Navy') ? NavyBranchOptions : MarineBranchOptions
              )}
              filterOptions={createFilter({ ignoreCase: true, ignoreAccents: true })}
            />
          )
        }

        return ''
      })()}
    </div>
  )
}

export default BranchSearch
